/*
 * Validate-login.ts
 * Description: Includes the a validation
 * function for the user form
 */

// Importing variables
import {
    InvalidEmail, EmailRegex, MissingPassword,
} from '../variables';

// Declaring user data interface
export interface User {
    email: string;
    password: string;
}

/**
 * Checking if user data is valid before sending the request
 *
 * @param {String[]} errors - register errors
 * @param {User} data - user data
 */
export function validateLoginForm(errors: string[], data: User) {
    // Validating email
    if (!EmailRegex.test(data.email)) { errors.push(InvalidEmail); }
    // Validating password
    if (data.password.length === 0) { errors.push(MissingPassword); }
}
